// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".grid-container[data-v-16153dfc]{padding-left:10px;padding-right:10px;height:100%}.flex-grid[data-v-16153dfc]{display:flex;flex-flow:column;flex:1}.padme-left-bottom[data-v-16153dfc]{padding:1.25rem 1rem;border-top:1px solid #d3d3d3}.content-select[data-v-16153dfc]{display:block;float:right}.footer[data-v-16153dfc]{min-width:5em}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
